import React, { useState, useEffect } from 'react'
// import ChartOptions from "../ChartOptions"
import ChartPreview from '../ChartPreview'
import { chart as rawChart } from '@rawgraphs/rawgraphs-core'
import { mapDataInWorker } from '../../worker'
import { WEBWORKER_ACTIVE } from '../../constants'


const ChartPreviewWithOptions = ({
  chart,
  dataset,
  dataTypes,
  mapping,
  visualOptions,
  setRawViz,
  chatExpanded,
  onExpandClick,
  expandStatus,
}) => {
  const [error, setError] = useState({ variant: "secondary", message: "Required chart variables" })
  const [mappedData, setMappedData] = useState(null)

  useEffect(() => {

    try {
      if (WEBWORKER_ACTIVE) {
        mapDataInWorker(chart.metadata.name, {
          data: dataset,
          mapping: mapping,
          dataTypes,
        }, chart.rawCustomChart)
          .then((mappedData) => {
            setMappedData(mappedData)
          })
          .catch((err) => {
            console.error(err)
            setMappedData(null)
          })
      } else {
        const viz = rawChart(chart, {
          data: dataset,
          mapping: mapping,
          dataTypes,
        })
        const vizData = viz._getVizData()
        setMappedData(vizData)
      }
    } catch (e) {
      console.error(e)
      setMappedData(null)
    }
  }, [
    chart,
    mapping,
    dataTypes,
    setError,
    setRawViz,
    dataset,
  ])

  return (
    <ChartPreview
      chart={chart}
      dataset={dataset}
      dataTypes={dataTypes}
      mapping={mapping}
      visualOptions={visualOptions}
      error={error}
      setError={setError}
      setRawViz={setRawViz}
      mappedData={mappedData}
      chatExpanded={chatExpanded}
      onExpandClick={onExpandClick}
      expandStatus={expandStatus}
    />
  )
}

export default ChartPreviewWithOptions